import React, { useState, useEffect } from 'react'
import ShopifyModal from '@/components/Shopify/ShopifyModal/ShopifyModal'
import { BlockStack, InlineStack, Text } from '@shopify/polaris';

const UpdateModal = () => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setIsOpen(true);
        }, 1000);
    }, []);

    return (
        <ShopifyModal open={isOpen}
            onClose={() => setIsOpen(false)}
            title={'🚀 Important Product Updates - Effective Date: 2025-09-15'}
            id='update-modal'
            primaryButton={{
                content: 'I understand',
                onAction: () => setIsOpen(false)
            }}
            secondaryButtons={[
                {
                    content: 'Contact us',
                    onAction: () => {
                        setIsOpen(false)
                        if (import.meta.env.PUBLIC_NODE_ENV === 'production') {
                            if(window.Willdesk){
                                window.Willdesk.chat('')
                            }
                        }
                     
                    }
                }
            ]}
            >
            <BlockStack gap='300'>
                <Text as='p' variant='bodyMd'>We're streamlining your customer service experience</Text>
                <BlockStack gap='200'>
                    <Text as='p' variant='headingSm' fontWeight='bold'>What's Changing:</Text>
                    <BlockStack gap='100'>
                        <InlineStack gap='100'>
                            <Text as='p' variant='headingSm' fontWeight='bold'>✨ New Chat Widget Design：</Text>
                            <Text as='p' variant='bodyMd'>Modern UI with better mobile experience</Text>
                        </InlineStack>
                        <InlineStack gap='100'>
                            <Text as='p' variant='headingSm' fontWeight='bold'>💬 Live Chat Focus：</Text>
                            <Text as='p' variant='bodyMd'>All customer inquiries through real-time chat</Text>
                        </InlineStack>
                        <InlineStack gap='100'>
                            <Text as='p' variant='headingSm' fontWeight='bold'><span style={{ color: '#FC1313' }}>📋 FAQ Feature Removal：</span></Text>
                            <Text as='p' variant='bodyMd'>FAQ management will be discontinued</Text>
                        </InlineStack>
                        <InlineStack gap='100'>
                            <Text as='p' variant='headingSm' fontWeight='bold'><span style={{ color: '#FC1313' }}>✉️ Email Us Removal：</span></Text>
                            <Text as='p' variant='bodyMd'>Replaced with instant Live Chat</Text>
                        </InlineStack>
                    </BlockStack>
                </BlockStack>

                <BlockStack gap='200'>
                    <Text as='p' variant='headingSm' fontWeight='bold'>Why These Changes?</Text>
                    <ul style={{ padding: '0 0 0 20px', margin: 0 }}>
                        <li><Text as='p' variant='bodyMd'>Live Chat delivers 3x better conversion rates</Text></li>
                        <li><Text as='p' variant='bodyMd'>Customers prefer instant help over waiting for emails</Text></li>
                        <li><Text as='p' variant='bodyMd'>Focused experience means better AI assistance</Text></li>
                        <li><Text as='p' variant='bodyMd'>Improved mobile customer experience</Text></li>
                    </ul>
                </BlockStack>
            </BlockStack>
        </ShopifyModal>
    )
}

export default UpdateModal;